import React, { FunctionComponent, useState, useEffect } from 'react';
import styles from './ProjectDetails.module.css';
import { IoIosAddCircleOutline} from 'react-icons/io';
import { ImFilePdf } from 'react-icons/im';
import { useLocation } from 'react-router-dom';
import { getDateAndTime } from '../../Values/utils';
import ProjectDocumentModal from '../../Components/Modals/ProjectDocumentModal/ProjectDocumentModal';
import {
  deleteProjectBrochures,
  deleteProjectForms,
  deleteProjectImage,
  deleteProjectLayouts,
  deleteProjectPriceLists,
  deleteProjectVideo,
  fetchProjectDocuments,
  setProjectImage,
  deleteProjectTemplate,
  deleteProjectMapURL
} from '../../Services/resources';
import { connect, useDispatch } from 'react-redux';
import { showSnackbarAction } from '../../Redux/actions';
import Loading from '../../Components/Loading/Loading';
import { MdDelete ,MdEdit} from 'react-icons/md';
import { firestore } from '../../Firebase';
import { fetchProjects } from '../../Services/contacts';
import {themeColors} from '../../Components/theme';
import ProjectVideoModal from '../../Components/Modals/ProjectVideoModal/ProjectVideoModal';
import { HiVideoCamera } from 'react-icons/hi';
import ProjectsNotesModal from '../../Components/Modals/NotesModal/ProjectsNotesModal';
import axios from 'axios';
import { url } from '../../Values/constants';
import MapAdress from '../../Components/Modals/NotesModal/MapAdress';
import {fetchProjectResources,removeAttachment} from "../../Services/projects"
import { googleAnalytics } from '../../Services/users';

type props = { user: any,theme:any, organizationData:any,authToken?: any,userPreference?:any};
const ProjectDetails: FunctionComponent<props> = ({ user,theme,organizationData,authToken,userPreference }) => {
  const location: any = useLocation();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [type, setType] = useState('');
  const [vidModal, setVidModal] = useState(false);
  const [brochures, setBrochures] = useState<any[] | undefined>(undefined);
  const [priceLists, setPriceLists] = useState<any[] | undefined>(undefined);
  const [layouts, setLayouts] = useState<any[] | undefined>(undefined);
  const [forms, setForms] = useState<any[] | undefined>(undefined);
  const [images, setImages] = useState<any[] | undefined>(undefined);
  const [load, setLoad] = useState(false);
  const [attachmentsList, setAttachmentsList] = useState<
    any[] | undefined
  >(undefined);
  const [allProjectData, setAllProjectData] = useState<any[]>([]);
  const [projectsList, setProjectsList] = useState<any[] | undefined>(
    undefined
  );
  const [isGACalled, setIsGACalled] = useState<any>(false);
  
  const dispatcher = useDispatch();
  let panel = ""
  const [template, setTemplate] = useState<any | undefined>(undefined);
  const [mapURL, setMapURL] = useState<any | undefined>();
  const [noteModal, setNoteModal] = useState(false);
  const [urlModal, setURLModal] = useState(false);

  useEffect(()=>{
    if(user.organization_id){
      fetchProjectResources(
        location.state.detail.project_id,
        location.state.detail.organization_id,
        (data) => setBrochures(data),
        (data) => setPriceLists(data),
        (data) => setLayouts(data),
        (data) => setForms(data),
        (data) => setAttachmentsList(data),
        (data) => setImages(data),
       setTemplate,
        setMapURL
      )
    }
  },[user])


  const deleteProjectResource = (attachment: any,type: any) => {
    removeAttachment(
      location.state.detail.project_id,
      location.state.detail.organization_id,
      attachment,
      type,
      dispatcher,
    );
  };
  const deleteImage = async (fileName: string, index: number) => {

    if (images) {
      await deleteProjectImage(
        'images',
        images,
        location.state.detail.project_id,
        index,
        fileName,
        dispatcher,
        location.state.detail.project_name,
        user,
        panel="Projects",
        authToken
      );
    }
  };
  const deleteVideo = async (fileName: string, index: number) => {
    
    if (attachmentsList) {
    
      await deleteProjectVideo(
        'video',
        attachmentsList,
        location.state.detail.project_id,
        index,
        fileName,
        dispatcher,
        location.state.detail.project_name,
        user,
        panel="Projects",
        authToken
      );
    }
  };
  const deleteBrochures = async (fileName: string, index: number) => {

    if (brochures) {
      await deleteProjectBrochures(
        'brochures',
        brochures,
        location.state.detail.project_id,
        index,
        fileName,
        dispatcher,
        location.state.detail.project_name,
        user,
        panel="Projects",
        authToken
      );
    }
  };
  const deletePriceLists = async (fileName: string, index: number) => {

    if (priceLists) {
      await deleteProjectPriceLists(
        'priceLists',
        priceLists,
        location.state.detail.project_id,
        index,
        fileName,
        dispatcher,
        location.state.detail.project_name,
        user,
        panel="Projects",
        authToken
      );
    }
  };
  const deleteLayouts = async (fileName: string, index: number) => {

    if (layouts) {
      await deleteProjectLayouts(
        'layouts',
        layouts,
        location.state.detail.project_id,
        index,
        fileName,
        dispatcher,
        location.state.detail.project_name,
        user,
        panel="Projects",
        authToken
      );
    }
  };
  const deleteForms = async (fileName: string, index: number) => {

    if (forms) {
      await deleteProjectForms(
        'forms',
        forms,
        location.state.detail.project_id,
        index,
        fileName,
        dispatcher,
        location.state.detail.project_name,
        user,
        panel="Projects",
        authToken
      );
    }
  };
  const deleteTemplate = async (fileName: string) => {
    if (template) {
      await deleteProjectTemplate(
        'template',
        template,
        location.state.detail.project_id,
        dispatcher,
        location.state.detail.project_name,
        user,
        panel="Projects",
        authToken
      );
    }
  };
  const deleteMapURL = async (fileName: string) => {
    if (mapURL) {
      await deleteProjectMapURL(
        'mapURL',
        mapURL,
        location.state.detail.project_id,
        dispatcher,
        location.state.detail.project_name,
        user,
        panel="Projects",
        authToken
      );
    }
  };

  const upload = async (data: FileList | null) => {
    if (data && user.organization_id) {
      setLoad(true);

      await setProjectImage(
        user.organization_id,
        data[0],
        projectsList,
        location.state.detail,
        location.state.detail.project_image ? true : false,
        dispatcher
      );
      setLoad(false);
      dispatcher(showSnackbarAction('Thumbnail Uploaded!!', 'success'));
    }
  };

  const containerStyles = {backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
  const cardContainerStyles = {backgroundColor:theme ? themeColors.cardBackgroundColor:themeColors.cardBackgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
  const tdStyles = {
    backgroundColor:theme?themeColors.tdBackgroundColor:themeColors.tdBackgroundColorDark,
    color:theme?themeColors.textPrimary:themeColors.textPrimaryDark,
  }
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Project_Details_Screen',user)
      }
    }
  },[user])
  return (
    <>
      {load === true && <Loading />}
      <div className={styles.parent} style={containerStyles}>
        <div className={styles.child}    style={containerStyles}>
          <div className={styles.documentContainer}>
            {!location.state.detail.type||location.state.detail.type ==="NEW PROJECT"?<h5 
            // className={styles.heading}
            >Project Documents</h5>:<h5 
            // className={styles.heading}
            >Documents</h5>}
            <div className={styles.docContainer} style={cardContainerStyles}>
            <div className={styles.addContainer}>
              <h6 
              // className={styles.title}
              >Images</h6>
              <IoIosAddCircleOutline
                color="#279ea0"
                size="20"
                onClick={() => {
                  setOpen(true);
                  setTitle('Add Image');
                  setType('images');
                }}
              />
            </div>
            <div className={styles.allDocuments}>
              {images?.map((item, index) => (
                <div className={styles.document}>
                  <ImFilePdf color="#808080" size="10" />
                  <p className={styles.name}>
                    {' '}
                    <a href={item.link}>{item.name}</a>
                  </p>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginLeft: 'auto',
                    }}
                  >
                    <MdDelete
                      color={'#ff0000'}
                      style={{}}
                      size={16}
                      onClick={() => {
                        userPreference.project_attachments_delete_approved ===
                        false
                          ? dispatcher(
                              showSnackbarAction(
                                "You are not allowed to delete project attachment. Please contact your admin!!",
                                "error"
                              )
                            )
                          : deleteProjectResource(item,"images");
                      }}
                    />
                  </div>
                </div>
              ))}
              {images?.length === 0 && (
                <p 
                // style={{ margin: '0px', fontSize: '12px' }}
                >
                  No Document Added
                </p>
              )}
            </div>
            </div>

            {/* Upload Video Work On project  */}
            <div className={styles.docContainer} style={cardContainerStyles}>
            <div className={styles.addContainer}>
              <h6 
              // className={styles.title}
              >Upload Video</h6>
              <HiVideoCamera
                      size={15}
                      color="#279ea0"
                      onClick={() => {
                        setVidModal(true);
                        setTitle("Upload Video");
                      }}
                    />
            </div>
            <div className={styles.allDocuments}>
              {attachmentsList?.map((item, index) => (
                <div className={styles.document}>
                  <ImFilePdf color="#808080" size="10" />
                  <p className={styles.name}>
                    {' '}
                    <a href={item.link}>{item.name}</a>
                  </p>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginLeft: 'auto',
                    }}
                  >
                    <MdDelete
                      color={'#ff0000'}
                      style={{}}
                      size={16}
                      onClick={() => {
                        userPreference.project_attachments_delete_approved ===
                        false
                          ? dispatcher(
                              showSnackbarAction(
                                "You are not allowed to delete project attachment. Please contact your admin!!",
                                "error"
                              )
                            )
                          : deleteProjectResource(item,"videos");
                      }}
                    />
                  </div>
                </div>
              ))}
              {attachmentsList?.length === 0 && (
                <p 
                // style={{ margin: '0px', fontSize: '12px' }}
                >
                  No Video Added
                </p>
              )}
            </div>
            </div>    
            {/* Upload Video Work On project  */}

            <div className={styles.docContainer} style={cardContainerStyles}>
            <div className={styles.addContainer}>
              <h6 
              // className={styles.title}
              >Brochures</h6>
              <IoIosAddCircleOutline
                color="#279ea0"
                size="20"
                onClick={() => {
                  setOpen(true);
                  setTitle('Brochures Document');
                  setType('brochures');
                }}
              />
            </div>
            <div className={styles.allDocuments}>
              {brochures?.map((item, index) => (
                <div className={styles.document}>
                  <ImFilePdf color="#808080" size="10" />
                  <p className={styles.name}>
                    {' '}
                    <a href={item.link}>{item.name}</a>
                  </p>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginLeft: 'auto',
                    }}
                  >
                    <MdDelete
                      color={'#ff0000'}
                      style={{}}
                      size={16}
                      onClick={() => {
                        userPreference.project_attachments_delete_approved ===
                        false
                          ? dispatcher(
                              showSnackbarAction(
                                "You are not allowed to delete project attachment. Please contact your admin!!",
                                "error"
                              )
                            )
                          : deleteProjectResource(item,"brochures");
                      }}
                    />
                  </div>
                </div>
              ))}
              {brochures?.length === 0 && (
                <p 
                // style={{ margin: '0px', fontSize: '12px' }}
                >
                  No Document Added
                </p>
              )}
            </div>
            </div>

           <div className={styles.docContainer} style={cardContainerStyles}>
           <div className={styles.addContainer}>
              <h6 
              // className={styles.title}
              >Pricelists</h6>
              <IoIosAddCircleOutline
                color="#279ea0"
                size="20"
                onClick={() => {
                  setOpen(true);
                  setTitle('PriceLists Document');
                  setType('priceLists');
                }}
              />
            </div>
            <div className={styles.allDocuments}>
              {priceLists?.map((item, index) => (
                <div className={styles.document}>
                  <ImFilePdf color="#808080" size="10" />
                  <p className={styles.name}>
                    {' '}
                    <a href={item.link}>{item.name}</a>
                  </p>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginLeft: 'auto',
                    }}
                  >
                    <MdDelete
                      color={'#ff0000'}
                      style={{}}
                      size={16}
                      onClick={() => {
                        userPreference.project_attachments_delete_approved ===
                        false
                          ? dispatcher(
                              showSnackbarAction(
                                "You are not allowed to delete project attachment. Please contact your admin!!",
                                "error"
                              )
                            )
                          : deleteProjectResource(item,"pricelists");
                      }}
                    />
                  </div>
                </div>
              ))}
              {priceLists?.length === 0 && (
                <p 
                // style={{ margin: '0px', fontSize: '12px' }}
                >
                  No Document Added
                </p>
              )}
            </div>
           </div>

            <div className={styles.docContainer} style={cardContainerStyles}>
            <div className={styles.addContainer}>
              <h6 
              // className={styles.title}
              >Layouts</h6>
              <IoIosAddCircleOutline
                color="#279ea0"
                size="20"
                onClick={() => {
                  setOpen(true);
                  setTitle('Layouts Document');
                  setType('layouts');
                }}
              />
            </div>
            <div className={styles.allDocuments}>
              {layouts?.map((item, index) => (
                <div className={styles.document}>
                  <ImFilePdf color="#808080" size="10" />
                  <p className={styles.name}>
                    {' '}
                    <a href={item.link}>{item.name}</a>
                  </p>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginLeft: 'auto',
                    }}
                  >
                    <MdDelete
                      color={'#ff0000'}
                      style={{}}
                      size={16}
                      onClick={() => {
                        userPreference.project_attachments_delete_approved ===
                        false
                          ? dispatcher(
                              showSnackbarAction(
                                "You are not allowed to delete project attachment. Please contact your admin!!",
                                "error"
                              )
                            )
                          : deleteProjectResource(item,"layouts");
                      }}
                    />
                  </div>
                </div>
              ))}
              {layouts?.length === 0 && (
                <p 
                // style={{ margin: '0px', fontSize: '12px' }}
                >
                  No Document Added
                </p>
              )}
            </div>
            </div>

            <div className={styles.docContainer} style={cardContainerStyles}>
            <div className={styles.addContainer}>
              <h6 
              // className={styles.title}
              >Forms</h6>
              <IoIosAddCircleOutline
                color="#279ea0"
                size="20"
                onClick={() => {
                  setOpen(true);
                  setTitle('Forms Document');
                  setType('forms');
                }}
              />
            </div>
            <div className={styles.allDocuments}>
              {forms?.map((item, index) => (
                <div className={styles.document}>
                  <ImFilePdf color="#808080" size="10" />
                  <p className={styles.name}>
                    {' '}
                    <a href={item.link}>{item.name}</a>
                  </p>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginLeft: 'auto',
                    }}
                  >
                    <MdDelete
                      color={'#ff0000'}
                      style={{}}
                      size={16}
                      onClick={() => {
                        userPreference.project_attachments_delete_approved ===
                        false
                          ? dispatcher(
                              showSnackbarAction(
                                "You are not allowed to delete project attachment. Please contact your admin!!",
                                "error"
                              )
                            )
                          : deleteProjectResource(item,"forms");
                      }}
                    />
                  </div>
                </div>
              ))}
              {forms?.length === 0 && (
                <p 
                // style={{ margin: '0px', fontSize: '12px' }}
                >
                  No Document Added
                </p>
              )}
            </div>
            </div>
            {/* -----------------------Project Detail Template---------------------------------------------------------------------------- */}
            <div className={styles.childNotes}
            style={containerStyles}
          >
            <div className={styles.notesSection} style={cardContainerStyles}>
              <div className={styles.notesHead}>
                {!location.state.detail.type||location.state.detail.type ==="NEW PROJECT"?<h6
                >Project Detail</h6>:<h6
                > Detail</h6>}
                {(template) &&
              <MdEdit
              color="#279ea0"
              size="20"
              style={{cursor:"pointer",}}
              onClick={() => {
                setNoteModal(true)
                setType('template');
              }}
            />}
                        {(!template) && 
                                    <IoIosAddCircleOutline
                                    color="#279ea0"
                                    size="20"
                                    style={{cursor:"pointer",}}
                                    onClick={() => {
                                      setNoteModal(true)
                                      setType('template');
                                    }}
                                  />
                        }
              </div>
            <div className={styles.container}>
              {( template) &&
                <div className={styles.template} style={{display:"flex",overflow:"auto"}}>
                  <p className={styles.name} style={{color:theme ?"black":"white"}}>
                    {' '}
                    {template}
                  </p>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginLeft: 'auto',
                    }}
                  >
                    <MdDelete
                      color={'#ff0000'}
                      style={{cursor:"pointer",}}
                      size={16}
                      onClick={() => {
                        deleteTemplate(template);
                      }}
                    />
                  </div>
                </div>
                }
                {(!template) && (
                <p >
                  No Detail Added{"  "}
                </p>
              )}
              </div>
            </div>
          </div>
            {/* ---------------------------------------------------------------------------------------- */}
            {/* -----------------------Project Detail Template---------------------------------------------------------------------------- */}
            <div className={styles.childNotes}
            style={containerStyles}
          >
            <div className={styles.notesSection} style={cardContainerStyles}>
              <div className={styles.notesHead}>
                <h6
                >Enter Map URL</h6>
                {(mapURL) &&
              <MdEdit
              color="#279ea0"
              size="20"
              style={{cursor:"pointer",}}
              onClick={() => {
                setURLModal(true)
                setType('mapURL');
              }}
            />}
                        {(!mapURL) && 
                                    <IoIosAddCircleOutline
                                    color="#279ea0"
                                    size="20"
                                    style={{cursor:"pointer",}}
                                    onClick={() => {
                                      setURLModal(true)
                                      setType('mapURL');
                                    }}
                                  />
                        }
              </div>
            <div className={styles.container}>
              {( mapURL) &&

                <div className={styles.template} style={{display:"flex",overflow:"auto"}}>
                  <p className={styles.name} style={{color:theme ?"black":"white"}}>
                    {' '}
                    {mapURL}
                  </p>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginLeft: 'auto',
                    }}
                  >
                    <MdDelete
                      color={'#ff0000'}
                      style={{cursor:"pointer",}}
                      size={16}
                      onClick={() => {
                        deleteMapURL(mapURL);
                      }}
                    />
                  </div>
                </div>
                }
                {(!mapURL) && (
                <p >
                  No URL Added{"  "}
                </p>
              )}
              </div>
            </div>
          </div>
            {/* ---------------------------------------------------------------------------------------- */}
          </div>

          <div className={styles.projectDetails}>
            {!location.state.detail.type||location.state.detail.type ==="NEW PROJECT"?<h5 
            // className={styles.detailsHeading}
            >Project Details</h5>:<h5 
            // className={styles.detailsHeading}
            >{location.state.detail.type} Details</h5>}
              <div className={styles.projectDataContainer} style={cardContainerStyles}>
              <div className={styles.data}>
              <p className={styles.head}>Project Name :</p>
              <p className={styles.text}>
                {location.state.detail.project_name}
              </p>
            </div>
            {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
            <div className={styles.data}>
              <p className={styles.head}>Developer Name :</p>
              <p className={styles.text}>
                {location.state.detail.developer_name}
              </p>
            </div>}
            <div className={styles.data}>
              <p className={styles.head}>Address :</p>
              <p className={styles.text}>{location.state.detail.address}</p>
            </div>
            {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
            <div className={styles.data}>
              <p className={styles.head}>Property Type :</p>
              <p className={styles.text}>
                {location.state.detail.property_type}
              </p>
            </div>}
            {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&(!location.state.detail.type||location.state.detail.type ==="NEW PROJECT")?
            <div className={styles.data}>
              <p className={styles.head}>RERA Link :</p>
              <p className={styles.text}>{location.state.detail.rera_link}</p>
            </div>:
            <div className={styles.data}>
            <p className={styles.head}>Owner Name :</p>
            <p className={styles.text}>{location.state.detail.owner_name}</p>
          </div>}
            {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&(!location.state.detail.type||location.state.detail.type ==="NEW PROJECT")?
            <div className={styles.data}>
              <p className={styles.head}>Walkthrough Link :</p>
              <p className={styles.text}>
                {location.state.detail.walkthrough_link}
              </p>
            </div>:
            <div className={styles.data}>
            <p className={styles.head}>Owner Contact No. :</p>
            <p className={styles.text}>{location.state.detail.owner_contact_no}</p>
          </div>}
          {location.state.detail.type !=="NEW PROJECT" &&
            <div className={styles.data}>
              <p className={styles.head}>{location.state.detail.type} Price:</p>
              <p className={styles.text}>{location.state.detail.price}</p>
            </div>}
            <div className={styles.data}>
              <p className={styles.head}>Created By :</p>
              <p className={styles.text}>{location.state.detail.created_by}</p>
            </div>
            <div className={styles.data}>
              <p className={styles.head}>Created Date & Time :</p>
              <p className={styles.text}>
                {getDateAndTime(location.state.detail.created_at, 'LLL')}
              </p>
            </div>
            <div 
            // className={styles.data}
            style={{
              // display: 'flex',
              // flex-direction: "row"
              width: "100%",
              alignItems: "center",
              justifyContent: "space-between",
              /* background-color: white;
              border-bottom: 3px solid #f3f3f3; */
              padding: "0.5rem"
              // box-sizing: border-box;
            }}
            >
              {!location.state.detail.type||location.state.detail.type ==="NEW PROJECT"?
              <p className={styles.head} style={{fontWeight:"bold",fontSize:18}}>Project Description :</p>
              :<p className={styles.head} style={{fontWeight:"bold",fontSize:18}}>Description :</p>}
              <p className={styles.text} style={{ overflow:"auto",whiteSpace: "pre-wrap",marginTop:"2%"}}>
              {location.state.detail.description}
              </p>
            </div>

            {/* <div className={styles.uploadContainer}>
              <div className={styles.selectBox}>
                <label htmlFor="file" className={styles.uploadButton}>
                  Upload Thumbnail
                </label>
                <input
                  id="file"
                  className={styles.select}
                  type="file"
                  accept=".png,.jpg,.jpeg"
                  onChange={(e) => upload(e.target.files)}
                />
              </div>
            </div>  */}
              </div>
          </div>
        </div>
        {open === true && (
          <ProjectDocumentModal
            open={open}
            close={() => setOpen(false)}
            title={title}
            projectData={location.state.detail}
            type={type}
            setLoad={(data) => setLoad(data)}
          />
        )}
        {vidModal && (
          <ProjectVideoModal
            open={vidModal}
            close={() => setVidModal(false)}
            title={title}
            type={"video"}
            projectData={location.state.detail}
            attachmentsList={
              attachmentsList ? attachmentsList : []
            }
            setLoad={(data) => setLoad(data)}
          />
        )}
        {noteModal === true && (
          <ProjectsNotesModal
            open={noteModal}
            close={() => setNoteModal(false)}
            projectData={location.state.detail}
            type={"text"}
            project_template={template ? template : ""}
            user={user}
            // authToken={authToken}
          />
        )}
        {urlModal === true && (
          <MapAdress
            open={urlModal}
            close={() => setURLModal(false)}
            projectData={location.state.detail}
            type={"text"}
            project_mapURL={mapURL ? mapURL : ""}
            user={user}
            // authToken={authToken}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    organizationData: state.organization.organizationData,
    authToken: state.user.authToken,
    userPreference: state.userPreference.data,
  };
};

export default connect(mapStateToProps)(ProjectDetails);
